import { render, staticRenderFns } from "./selectNewCategoryDetail.vue?vue&type=template&id=4f7685b6&scoped=true&"
import script from "./selectNewCategoryDetail.vue?vue&type=script&lang=js&"
export * from "./selectNewCategoryDetail.vue?vue&type=script&lang=js&"
import style0 from "../../statistics/css/hunting.css?vue&type=style&index=0&id=4f7685b6&scoped=true&lang=css&"
import style1 from "./selectNewCategoryDetail.vue?vue&type=style&index=1&id=4f7685b6&scoped=true&lang=css&"
import style2 from "./selectNewCategoryDetail.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7685b6",
  null
  
)

export default component.exports